export const SAVE_CENTER_COORDS = "SAVE_CENTER_COORDS";
export const SAVE_MAP_TO_STATE = "SAVE_MAP_TO_STATE";
export const SHOW_SPINNER = "SHOW_SPINNER";
